<template>
  <div class="index"></div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      totalAmount: 0,
      hisAmount: 0,
      balance: 0
    };
  },
  created() {
    this.$axios.get("/order/getTodayAmount", { params: {} }).then((res) => {
      if (res.code === 200) {
        this.totalAmount = (res.data.amount / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    });

    this.$axios.get("/order/getHistoryAmount", { params: {} }).then((res) => {
      if (res.code === 200) {
        this.hisAmount = (res.data.amount / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    });

    this.$axios.get("/merchant/getBalance", { params: {} }).then((res) => {
      if (res.code === 200) {
        this.balance = (res.data / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    });
  }
};
</script>

<style scoped>
.index {
  margin: 20px;
}

.text {
  font-size: 28px;
  text-align: center;
}

.item {
  margin-bottom: 18px;
}

.clearfix {
  text-align: center;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}

.box-card {
  width: 240px;
  display: inline-block;
  margin-left: 20px;
}
</style>
